Number.prototype.format = function(n, x) {
  var re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
  return this.toFixed(Math.max(0, ~~n)).replace(new RegExp(re, "g"), "$&.");
};

String.prototype.capitalize = function() {
  if (this == "BMW" || this == "Land Rover" || this == "Mercedes-Benz") {
    return this;
  }

  if (this == "Citroën") {
    return "Citroen";
  }

  if (this == "volkswagen") {
    return "VW";
  }
  return this.charAt(0).toUpperCase() + this.slice(1).toLocaleLowerCase();
};

//Init fb sdk
 window.fbAsyncInit = function() {
  FB.init({
    appId: "268857474012014",
    cookie: true,
    status: true,
    xfbml: true,
    version: "v4.0"
  });

  FB.getLoginStatus(function(response) {
    // console.log(response);
  });
};

(function(d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");
